module.exports = __webpack_public_path__ + "static/media/user.c1176ca8.svg";